import { useState } from "react";
import { TenantsTable } from "./TenantsTable";
import { CreateTenantModal } from "./CreateTenantModal";
import { ImpersonateModal } from "./ImpersonateModal";

/**
 * The Tenants section, with its two dialogs.
 *
 * Creating a tenant and impersonating stay local state rather than becoming
 * routes: they are actions taken on this screen, not places you navigate to,
 * and a URL that reopens a half-filled creation form or re-triggers an
 * impersonation would be a trap rather than a convenience.
 */
export function TenantsRoute() {
  const [showCreate, setShowCreate] = useState(false);
  const [impersonateTid, setImpersonateTid] = useState<string | null>(null);
  const [reloadKey, setReloadKey] = useState(0);

  return (
    <>
      <TenantsTable
        key={reloadKey}
        onCreate={() => setShowCreate(true)}
        onImpersonate={(tid) => setImpersonateTid(tid)}
      />
      {showCreate && (
        <CreateTenantModal
          onClose={() => setShowCreate(false)}
          onDone={() => {
            setShowCreate(false);
            setReloadKey((k) => k + 1);
          }}
        />
      )}
      {impersonateTid && (
        <ImpersonateModal tenantId={impersonateTid} onClose={() => setImpersonateTid(null)} />
      )}
    </>
  );
}
